import request from '@utils/request'

export function fetchBrokerageList(params) {
  return request({
    url: `/brokerage`,
    params,
  })
}

export function fetchBrokerage(seq) {
  return request({
    url: `/brokerage/${seq || 0}`,
    method: 'get',
  })
}

export function fetchShareList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/share`,
    method: 'get',
    params,
  })
}

export function fetchBalanceList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/balance`,
    method: 'get',
    params,
  })
}

export function fetchAdjustList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/adjust`,
    method: 'get',
    params,
  })
}

export function createAdjust(data) {
  return request.post('/brokerage/adjust', data)
}

export function createBrokerage(data) {
  return request.post('/brokerage', data)
}

export function updateBrokerage(data) {
  return request.put(`/brokerage/${data.seq}`, data)
}

export function fetchRelationList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/relation`,
    method: 'get',
    params,
  })
}

export function fetchMemberList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/member`,
    method: 'get',
    params,
  })
}

export function fetchPgMerchantList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/pg-merchant`,
    method: 'get',
    params,
  })
}

export function fetchOutsiteTransactionList(params) {
  return request({
    url: `/brokerage/${params.seq || params.brokerage_seq}/outsite-transaction`,
    method: 'get',
    params,
  })
}
